// Badge WRITE/READ mode — sans emoji (règle Ellmalike absolue).

import { IconLock, IconWarning } from './Icons'

export function BadgeMode({ writeMode, expiresInMs }: { writeMode: boolean; expiresInMs?: number | null }) {
  if (writeMode) {
    const mins = expiresInMs != null ? Math.max(0, Math.round(expiresInMs / 60000)) : null
    return (
      <span className="badge-mode badge-write" title="Mutations Teogest autorisées">
        <IconWarning size={14} strokeWidth={2} />
        WRITE ACTIVÉ{mins != null ? ` — expire dans ${mins} min` : ''}
      </span>
    )
  }
  return (
    <span className="badge-mode badge-read" title="Aucune mutation ne peut être envoyée à Teogest">
      <IconLock size={14} strokeWidth={2} />
      READ-ONLY
    </span>
  )
}
